import { GenericValue } from 'hisng';
import { Patent } from 'app/fs/res/patent/model/patent/patent';
import { Person } from 'app/fs/res/common/model/person/person';
import { ResearchPartnerSimple } from 'app/fs/res/common/model/researchPartner/researchPartner';

export class PatentDocument { // MOCK check with data model / backend
    id: number;
    filename: string;
    description: string;
    created: string; // Date
    url: string;
    constructor( id: number ) {
        this.id = id;
    }
}

export class PatentInventor {
    id: number;
    patent: Patent;
    organization: GenericValue;
    researchPartner: GenericValue | ResearchPartnerSimple;
    percentage: number;
    person: Person;
    sortorder: number;
    hasVisibleAffiliations: boolean;

    constructor( id?: number, person?: Person, percentage?: number ) {
        this.id = id;
        this.person = person;
        this.percentage = percentage;
    }
}

export class OrganizationPatent {
    organization: GenericValue; // internal organization
    researchPartner: ResearchPartnerSimple; // external organization
    constructor( organization?: GenericValue, researchPartner?: ResearchPartnerSimple );
    constructor( organization: GenericValue, researchPartner: ResearchPartnerSimple ) {
        this.organization = organization;
        this.researchPartner = researchPartner;
    }
}
